import { InjectionToken } from '@angular/core';

export type CloseSystemError = () => void;

/** Injection token for closing system error. */
export const SYSTEM_ERROR_CLOSE = new InjectionToken<CloseSystemError>('systemErrorCloseFunction');
